// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PPyv","type":"styles_type__1jSsF","choices":"styles_choices__mAWpp"};